import { useNavigate } from 'react-router-dom';

import useProtectAction from '@/hooks/useProtectAction';
import useTranslations from '@/i18n/useTranslations';
import { createCommunityArtworkNavigationState } from '@/shared/lib/communityArtworkNavigation';
import ArtworkImage from '@/shared-components/cards/components/ArtworkImage';
import CardHeader from '@/shared-components/cards/components/CardHeader';
import Text from '@/shared-components/text/components/Text';
import Utils from '@/utils';
import { hasRenderableRating } from '@/utils/activityContent';

import './styles/CommunityNotRatedCard.css';

export default function CommunityNotRatedCard({ data, actor }) {
  const tRatingForm = useTranslations('common.shared.artwork_view.socials.ratings.form');
  const t = useTranslations('common.shared.community_feed');
  const privateActionHandler = useProtectAction({ typeOfProtection: "USER_ACCOUNT_REQUIRED" });
  const navigate = useNavigate();
  const revealRatingEntry = {
    _id: data?._id ?? null,
    createdAt: data?.createdAt ?? null,
    rating_values: data?.rating_values ?? null,
    rating_creator: data?.rating_creator ?? null,
  };
  const navigateToRating = () => {
    navigate(`/artwork/${data.rating_artwork.slug}?rate=true`, {
      state: createCommunityArtworkNavigationState({ revealRatingEntry }),
    });
  };
  if (!hasRenderableRating(data)) {
    return null;
  }

  return (
    <>
      <div className="community-not-rated-card__outter-container">
        <div
          className="community-not-rated-card__container"
          onClick={navigateToRating}
        >
          <CardHeader
            image={actor?.image}
            profileType={actor?.profileType}
            username={actor?.username}
            onUserClick={() => navigate(`/user/${actor?.username}`)}
            timeAgo={Utils.elapsedTime(new Date(data.createdAt).getTime())}
            subtitle={
              <>
                {t('activity.rated')} <span className="community-not-rated-card__artwork-title">{data.rating_artwork.artwork_about.artwork_title}</span>
              </>
            }
          />

          <ArtworkImage
            image={data.rating_artwork.artwork_media.artwork_main_picture.image_id}
            imageClassName="community-not-rated-card__artwork-image"
            imageTemplateClassName="community-not-rated-card__artwork-image"
            // forceSmaller={300}
          />

          <div className="community-not-rated-card__rate-section">
            <Text className="community-not-rated-card__text" paragraph>
              {tRatingForm('headline')}
            </Text>

            <Text
              className="community-not-rated-card__rate-button"
              onClick={(e) => {
                e.stopPropagation();
                privateActionHandler(navigateToRating);
              }}>
              {t('actions.rate')}
            </Text>
          </div>
        </div>
      </div>
    </>
  );
}
